module.exports = __webpack_public_path__ + "img/img_auth_upGuide_info_top_bg.4249d324.png";